export default "__VITE_ASSET__CnD1AEP8__"